import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'textSlice' })
export class TextSlicePipe implements PipeTransform {
  transform(text: string): string {
    if (!text) return '';
    if (text.length < 25) return text;
    return `${text.slice(0, 15)}...${text.slice(-6)}`;
  }
}
